import { app, payload } from "modular-openscriptjs";
import { inform } from "./helpers";
import { Filter } from "./fotastart";
import { STRINGS } from "./declarations";
import { api, rPipeline } from "./declarations";
import { EchoEventListener } from "./classes/EchoEventListener";
import AlgoliaSearch from "./classes/AlgoliaSearch";

// base url was set in the _footer-scripts.blade
api.baseUrl = import.meta.env.VITE_API_BASE_URL || "/api/v1";

app().singleton("EchoEventListener", EchoEventListener);
app().singleton("AlgoliaSearch", AlgoliaSearch);

// add filters to the default Pipeline
rPipeline
	.add(
		new Filter(
			/**
			 * @param {Response} response
			 */
			async (response) => {
				let silentError = response.silent ?? false;

				try{
					let res = await response.json();
	
					if (response.ok) return Filter.output(res, true);

					// A guest (or someone whose session expired) hit an
					// account-only endpoint: offer the login modal instead of
					// a raw "Unauthenticated." error. Silent requests are
					// background fetches the user didn't ask for, so they
					// just fail quietly.
					if (response.status === 401) {
						if (!silentError) {
							app("broker").send(
								app("$e").user.needs.authentication,
								payload({ reason: "Please sign in to continue" })
							);
						}

						return Filter.output(false, false);
					}
	
					if (response.status === 419) {
						response.silent = true;
						res.message = "An error occurred, please try again.";
					}
	
					if (!silentError) inform(res.message, STRINGS.ERROR);
				}
				catch (e) {
					if(e instanceof SyntaxError) return Filter.output(false, false);

					if (!silentError) inform("An error occurred", STRINGS.ERROR);
				}

				return Filter.output(false, false);
			}
		)
	)
	.add(
		new Filter(async (data) => {
			if (data.status === STRINGS.SUCCESS)
				return Filter.output(
					{ message: data.message, data: data.data },
					true
				);

			// show error message
			inform(data.message, STRINGS.ERROR);

			return Filter.output(false, false);
		})
	);

api.pipeline(rPipeline);